import { render, staticRenderFns } from "./DemoAccountsTab.vue?vue&type=template&id=09a8a5fb"
import script from "./DemoAccountsTab.vue?vue&type=script&lang=js"
export * from "./DemoAccountsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports